/* SuccessMessage.ts */

export const SuccessMessage = {
  LOGOUT_SUCCESSFUL: "Logout successful",
  FLUSH_CACHE: "Cache flushed successfully",
};
